import { EventFieldGrid } from '@klear/order-event-ui/event-forms/event-field-grid'
import { dateFormatted, type DateDisplayInput } from '@klear/order-event/list-display'
import {
  EventDatePicker,
  EventFileInput,
  EventDocumentList,
  EventInput,
  EventMoneyInput,
  EventTextarea
} from '@klear/order-event-ui/event-shared/event-form-control'
import { Money } from '@klear/money'

export function InvoiceForm() {
  return (
    <>
      <EventFileInput label="Upload File(s)" name="files" multiple />
      <EventDocumentList />
      <div className="grid grid-cols-2 gap-4">
        <EventInput label="Number" name="number" />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <EventMoneyInput name="amount" label="Amount" />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <EventDatePicker label="Invoice Date" name="effectiveDate" />
        <EventDatePicker label="Collection Date" name="endDate" />
      </div>
      <EventTextarea label="Notes" name="notes" />
    </>
  )
}

type InvoiceViewData = {
  number?: string
  effectiveDate: DateDisplayInput
  endDate: DateDisplayInput
  amount: Money
}

export function InvoiceView({ invoice }: { invoice: InvoiceViewData }) {
  return (
    <EventFieldGrid
      fields={[
        { label: 'Amount', value: new Money(invoice.amount).toString() },
        { label: 'Collection Date', value: dateFormatted(invoice.endDate) }
      ]}
    />
  )
}
